import { UpsellPageDataDbWrite } from "@redotech/redo-conversion-core-common/upsell-page/upsell-page-db-validator";
import CheckCircleIcon from "@redotech/redo-icons/check-circle.svg";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { PostPurchaseBanner } from "./builder/post-purchase-elements/post-purchase-banner";
import { PostPurchaseProductTile } from "./builder/post-purchase-elements/post-purchase-product-tile";
import { PostPurchaseTimer } from "./builder/post-purchase-elements/post-purchase-timer";
import { PhoneFrame } from "./phone-frame";
import * as css from "./post-purchase-mobile-preview.module.css";

/**
 * Renders the mobile version of a post-purchase upsell page inside a phone
 * frame: the order-confirmed header, the page's banner and timer, and the
 * builder's product tiles (stacked variant) so the preview matches the PPU
 * builder's mobile view. Product details (image, price, variants) are fetched
 * live by PostPurchaseProductTile via the storefront client.
 */
export const PostPurchaseMobilePreview = memo(
  function PostPurchaseMobilePreview({
    upsellPageData,
  }: {
    upsellPageData: UpsellPageDataDbWrite;
  }) {
    const { layout } = upsellPageData;
    return (
      <PhoneFrame>
        <ConfirmationHeader />
        {layout.banner.showBanner && (
          <PostPurchaseBanner banner={layout.banner} px="xl" />
        )}
        {layout.timer.showTimer && <PostPurchaseTimer timer={layout.timer} />}
        <Flex dir="column" gap="lg" py="lg">
          {layout.upsellProducts.map((product, index) => (
            <PostPurchaseProductTile key={index} product={product} stacked />
          ))}
        </Flex>
      </PhoneFrame>
    );
  },
);

const ConfirmationHeader = memo(function ConfirmationHeader() {
  return (
    <Flex
      align="center"
      className={css.confirmationHeader}
      gap="sm"
      px="xl"
      py="lg"
    >
      <CheckCircleIcon className={css.confirmationIcon} />
      <Flex dir="column">
        <Text fontSize="xxs" textColor="secondary">
          Confirmation #12345670
        </Text>
        <Text fontSize="xs" fontWeight="semibold">
          You've paid for your order
        </Text>
      </Flex>
    </Flex>
  );
});
